import { useState, useEffect } from 'react'

const useIntersectionObserver = (
  ref: React.RefObject<Element>,
  options: IntersectionObserverInit = { threshold: 0.8 }
) => {
  const [isIntersecting, setIsIntersecting] = useState(false)
  const [hasIntersected, setHasIntersected] = useState(false)

  useEffect(() => {
    if (!ref.current) return

    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting && !hasIntersected) {
        setIsIntersecting(true)
        setHasIntersected(true)
      }
    }, options)

    observer.observe(ref.current)

    return () => {
      observer.disconnect()
    }
  }, [ref, options, hasIntersected])

  return isIntersecting
}

export default useIntersectionObserver
